export default __webpack_public_path__ + "static/media/write-paper.475cfdf8.svg";